/* eslint-disable */

import axios from "axios";

const instance = axios.create({
  baseURL: "https://yourcode-staging.com/api-niu/public",
  headers: {
    "content-type": "application/json",
    "Authorization": "Basic YXBpX3Jlb3JnYW5pemFfdXNlcjplNksvNzVKMylwWX5zXndM",
  },
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
});

export default {
  // SIGN IN
  async login(data) {
    try {
      const res = await instance.post("/api/login", data);
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },

  //PERFIL
  async buscarDados(data) {
    try {
      const res = await instance.post("/api/buscar/dados", data);
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },
  async buscarDadosTodos() {
    try {
      const res = await instance.post("/api/buscar/dados/todos");
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },

  //ESCOLHER GRUPO
  async escolherGrupo(data) {
    try {
      const res = await instance.post("/api/escolha/grupo", data);
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },

  //ESCOLHER Atividades
  async buscarAtividadesGrupo(data) {
    try {
      const res = await instance.post("/api/atividades/grupo", data);
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },
  async buscarAtividades(data) {
    try {
      const res = await instance.post("/api/atividades", data);
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },
  async buscarAtividadesInfo(data) {
    try {
      const res = await instance.post("/api/atividades/encerradas", data);
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },
  async atualizarAtividadesInfo(data) {
    try {
      const res = await instance.post(
        "/api/atividades/encerradas/atualizar",
        data
      );
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },

  //VERIFICAR VAGAS ATIVIDADES

  async verificarVaga(data) {
    try {
      const res = await instance.post("/api/verificar/vagas", data);
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },
  async limparVagas(data) {
    try {
      const res = await instance.post("/api/limpar/vagas", data);
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },

  //ESCOLHER ATIVIDADES

  async escolherAtividades(data) {
    try {
      const res = await instance.post("/api/escolher/atividades", data);
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },

  //ATRIBUIR PONTOS / PRESENCAS
  async atribuirPontos(data) {
    try {
      const res = await instance.post("/api/atribuir/pontos", data);
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },

  //ENVIAR MENSAGEM

  async registarMensagem(data) {
    try {
      const res = await instance.post("/api/registar/mensagem", data);
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },

  //ENVIAR ALERTAS

  async registarAlertas(data) {
    try {
      const res = await instance.post("/api/registar/alertas", data);
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },

  //UPLOAD IMAGEM BD

  async uploadImagem(data) {
    try {
      const res = await instance.post("/api/upload/imagem", data);
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },

  // BUSCAR MENSAGENS
  async buscarMensagens(data) {
    try {
      const res = await instance.post("/api/mensagens/listar", data);
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },

  // BUSCAR ALERTAS
  async buscarAlertas(data) {
    try {
      const res = await instance.post("/api/alertas/listar", data);
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },

  //BUSCAR IMAGENS
  async buscarImagens(data) {
    try {
      const res = await instance.post("/api/imagens/listar", data);
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },

  //APAGAR IMAGENS
  async apagarImagem(data) {
    try {
      const res = await instance.post("/api/imagens/apagar", data);
      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },
};
